import { render, staticRenderFns } from "./buyCardApply.vue?vue&type=template&id=634e18d4&scoped=true&"
import script from "./buyCardApply.vue?vue&type=script&lang=js&"
export * from "./buyCardApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634e18d4",
  null
  
)

export default component.exports